import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react'; 
import appConfig from 'app-config';
import { DocumentsPage } from 'gw-capability-document-react';
import { PolicyService, RenewalService } from 'gw-capability-gateway';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PageHeaderComponent } from 'gw-capability-gateway-react/Components/FormattedHeaderComponent/FormattedHeaderComponent';
import CommonRoutes from '../Common/CommonRouting';
import pageRouting from '../Common/Renewal-config.json5';
import metadata from './Renewal.metadata.json5';
import styles from './Renewal.module.scss';

const { capabilitiesConfig } = appConfig;

const DocumentPageService = {
    getDocuments: RenewalService.getDocumentsForRenewal,
    generateUploadToken: GatewayDocumentService.generateUploadToken,
    uploadDocument: GatewayDocumentService.uploadDocument,
    removeDocument: GatewayDocumentService.removeDocument,
    downloadDocument: GatewayDocumentService.downloadDocument,
};

function getRoutes() {
    const documentRoute = {
        path: '/documents',
        component: DocumentsPage,
    };

    if (
        isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'document' })
    ) {
        return [...pageRouting, documentRoute];
    }

    return pageRouting;
}

class Renewal extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                jobNumber: PropTypes.string,
            }),
            url: PropTypes.string,
        }).isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }).isRequired,
    };

    state = {
        currentView: 'summary',
        tileCountData: {},
        renewal: {},
        lobData: {}
    };

    componentDidMount() {
        this.getRenewalSummaryCount();
        this.getJobByJobNumber();
    }

    handleTilesOnClick = id => {
        this.setState({ currentView: id });
    };

    getRenewalSummaryCount = () => {
        const {
            authHeader,
            match: {
                params: { jobNumber },
            },
            location: { pathname },
        } = this.props;

        const routePath = pathname && (pathname.trim().split('/') || []);
        const selectedPageFromPath = routePath[routePath.length - 1];
        const activeTile = selectedPageFromPath || 'summary';

        RenewalService.getRenewalSummary(jobNumber, authHeader).then(
            response => {
                this.setState({
                    currentView: activeTile,
                    tileCountData: response,
                });
            }
        );
    };

    updateRenewalSummary = renewal => {
        this.setState({ renewal });
    };

    getJobByJobNumber = async () => {
        const {
            authHeader,
            match: {
                params: { jobNumber },
            },
        } = this.props;

        const renewal = await RenewalService.findJobByJobNumber(
            jobNumber,
            authHeader
        );

        this.getLobDataForTransaction(renewal)

        this.updateRenewalSummary(renewal);
    };

    getLobDataForTransaction = async(renewal) => {
        const { authHeader} = this.props;

        if(renewal && renewal.latestPeriod){
            const periodId = renewal.latestPeriod.publicID

            const lobData = await PolicyService.getLobData_TWIA(
                periodId,
                authHeader
            );
    
            this.setState({
                lobData
            })
        }

        
    }

    render() {
        const { currentView, tileCountData, renewal } = this.state;

        if (_.isEmpty(renewal)) {
            return null;
        }

        const renewalVM = {
            renewal,
            tileCountData,
        };
        const overrides = {
            [currentView]: {
                active: true,
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick,
            },
            resolveComponentMap: {
                pageheadercomponent: PageHeaderComponent,
            },
        };
        const QuoteDetailspage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={renewalVM}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        );
        const {
            match: {
                url,
                params: { jobNumber },
            },
        } = this.props;
        const quoteData = {
            jobNumber,
            loadRenewalSummary: renewal,
            updateJobSummary: this.updateRenewalSummary,
            getRenewalSummaryCount: this.getRenewalSummaryCount,
            lobData: this.state.lobData
        };

        return (
            <DependencyProvider value={{ DocumentPageService }}>
                {QuoteDetailspage}
                <CommonRoutes
                    steps={getRoutes()}
                    basePath={url}
                    setDocumentCount={this.getRenewalSummaryCount}
                    jobNumber={jobNumber}
                    quoteDetailsData={quoteData}
                />
            </DependencyProvider>
        );
    }
}

export default withRouter(withAuthenticationContext(Renewal));
